export default {
  addBtn: 'アニメーションの追加',
  customize: 'カスタムアニメーション',
}
